<template>
  <b-card
      title="مدیریت اسلایدشو"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                  class="mb-1 mr-auto ml-1"
                  variant="primary"
                  :to="{ name: 'addslideshow'}"
              >
                جدید
              </b-button>
<!--              <b-button-->
<!--                  variant="success"-->
<!--                  class="mb-1 mr-auto ml-1"-->
<!--                  @click="clearCache"-->
<!--              >-->
<!--                بروزرسانی-->
<!--              </b-button>-->
              <b-col md="2">
                <b-form-group
                    label="عنوان"
                    label-for="Title"
                >
                  <b-form-input
                      v-model="filterOptions.Title"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="نوع کالا"
                    label-for="DivisionId"
                >
                  <z-division
                      v-model="filterOptions.DivisionId"
                      :multiple="false"
                      :clearable="true"
                  />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group
                    label="سبک"
                    label-for="StyleId"
                >
                  <z-style
                      v-model="filterOptions.StyleId"
                      :multiple="false"
                      :clearable="true"
                      :division-id="filterOptions.DivisionId"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="وضعیت"
                    label-for="IsActive"
                >
                  <v-select
                      v-model="filterOptions.IsActive"
                      :options="enums('IsActive')"
                      dir="rtl"
                      label="text"
                      :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  class="mb-1 mr-1"
                  variant="warning"
                  @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
                :to="{ name: 'updateslideshow', params: { id: data.value }}"
                class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Title)="data">
            <span class="text-nowrap">
              <b-avatar
                  class="mr-50"
                  :src="data.item.Image"
              />
              {{ data.value }}
            </span>
          </template>

          <template #cell(Division)="data">
            <b-badge
                variant="light-primary"
            >
              {{ data.item.Budget.Style.Division.Title }}
            </b-badge>
          </template>

          <template #cell(Style)="data">
            <b-badge
                variant="light-info"
            >
              {{ data.item.Budget.Style.Title }}
            </b-badge>
          </template>

          <template #cell(Budget)="data">
            <b-badge
                variant="light-secondary"
            >
              {{ data.item.Budget.Title }}
            </b-badge>
          </template>

          <template #cell(IsActive)="data">
            <b-badge
                :variant="data.value ? 'success' : 'warning'"
            >
              {{ data.value ? 'فعال' : 'غیرفعال' }}
            </b-badge>
          </template>

          <template #cell(actions)="data">

            <div
                class="text-nowrap"
            >
              <b-link :to="{ name: 'updateslideshow', params: { id: data.item.Id }}">
                <feather-icon
                    :id="`invoice-row-${data.item.Id}-send-icon`"
                    icon="EditIcon"
                    size="16"
                />
              </b-link>

              <feather-icon

                  icon="TrashIcon"
                  size="16"
                  class="ml-1 cursor-pointer"
                  @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />

      </b-col>

    </b-row>
  </b-card>
</template>

<script>
import ZDivision from "@/tools/division.vue";
import ZStyle from "@/tools/style.vue";

export default {
  name: 'Slideshow',
  components: {ZStyle, ZDivision},
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
        Type: 0,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'Division',
          label: 'نوع کالا',
        },
        {
          key: 'Style',
          label: 'سبک',
        },
        {
          key: 'Budget',
          label: 'بودجه',
        },
        {
          key: 'IsActive',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
          this.$api.slideshow.getlist, this.filterOptions,
      )
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    },
    clearCache() {
      this.loading = true

      this.$http.post(
          this.$api.slideshow.clearcache, null,
      )
          .then(res => {
            this.update()
          })
    },
    remove(id) {
      this.removeRow(this.$api.slideshow.remove, 'Id', id)
    },
  },
}
</script>

<style scoped>

</style>